import React, { useState, useEffect } from 'react';
import { MultiSelect } from '@mantine/core';

const OSelect = props => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [changedValue, setChangedValue] = useState(false);

	const {
		label,
		labelExtra = '',
		name,
		value,
		onSelect,
		handleLabelOptions,
		disabled,
		requestApi,
		itemsSelect = [],
		isMulti = false,
		maxSelectedValues,
		validation,
		isRequired,
		value_key = '_id',
	} = props;

	const [isLoading, setIsLoading] = useState(true);
	const [isDisabled, setIsDisabled] = useState(true);
	const [listItemsSelect, setListItemsSelect] = useState([]);
	const [selectedValues, setSelectedValues] = useState([]);
	const [valueSelect, setValueSelect] = useState(null);

	const getItems = async () => {
		setIsLoading(true);
		let response = null;

		try {
			response = await requestApi();
			let itemsSelect = [];
			response.map(item => {
				itemsSelect.push({
					item: item,
					value: item[value_key],
					code: item.code,
					label:
						handleLabelOptions === undefined
							? item.name
							: handleLabelOptions(item),
				});
			});
			setListItemsSelect(itemsSelect);
			setIsLoading(false);
		} catch (err) {
			switch (err.status) {
				default:
					console.log(err.message);
			}
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (requestApi != null) {
			getItems();
		} else {
			setListItemsSelect(itemsSelect);
			setIsLoading(false);
		}
		setIsDisabled(disabled);

		return () => {
			// validation.setFieldTouched(name, true);
			// validation.setFieldValue(name, '');
			// validation.validateField(name);
			// setFirstChangeSelectedValues(false);
		};
	}, []);

	// Refresh items when itemsSelect prop changes (for local-provided options)
	useEffect(() => {
		if (requestApi == null) {
			setListItemsSelect(itemsSelect);
			setIsLoading(false);
		}
	}, [itemsSelect]);

	useEffect(() => {
		setIsDisabled(disabled);
	}, [disabled]);

	useEffect(() => {
		setSelectedValues(Array.isArray(value) ? value : value ? [value] : []);
	}, [listItemsSelect, value]);

	function selectionSelectRefresh() {
		// Handle return single or multiple value
		const values = isMulti
			? selectedValues
			: selectedValues
			? selectedValues[0]
			: '';

		// Set touched field to show errors
		// Change value select
		setValueSelect(values);
	}

	useEffect(() => {
		// Set touched field to show errors
		// set value to field and
		// apply validation with new value

		if (!isDropdownOpen && !isLoading) {
			if (changedValue && value) {
				validation.setFieldTouched(name);
			}

			validation.setFieldValue(name, valueSelect ? valueSelect : null, true);

			if (!changedValue && value != null) {
				setChangedValue(true);
			}

			// Pass full info item onSelect handle
			if (onSelect != null) {
				if (valueSelect) {
					let elementFounded = null;
					if (Array.isArray(valueSelect)) {
						elementFounded = listItemsSelect
							.map(item =>
								valueSelect.includes(item.value) ? item : null
							)
							.filter(item => item != null);
					} else {
						elementFounded = listItemsSelect.find(
							item => item.value == valueSelect
						);
					}
					if (elementFounded) {
						if (Array.isArray(valueSelect)) {
							onSelect(elementFounded);
						} else {
							onSelect(elementFounded.item);
						}
					} else {
						// Clear onSelect if no matching item is found
						if (Array.isArray(valueSelect)) {
							onSelect([]);
						} else {
							onSelect(null);
						}
					}
				} else {
					// Clear onSelect if values is undefined or null
					onSelect(null);
				}
			}
		}
	}, [valueSelect, isDropdownOpen, isLoading]);

	useEffect(() => {
		selectionSelectRefresh();
	}, [selectedValues]);

	useEffect(() => {
		if (validation.values[name] === '' && value === '') {
			validation.setFieldTouched(name, false);
			setSelectedValues([]);
		}
	}, [validation.values[name]]);

	return (
		<React.Fragment>
			<label htmlFor={`${name}`} className='form-label'>
				{label} {isRequired && <span style={{ color: 'red' }}>*</span>}
				{labelExtra ? ` ${labelExtra}` : labelExtra}
				{labelExtra ? ` ${labelExtra}` : labelExtra}
			</label>
			<MultiSelect
				key={`${validation.values[name]}`}
				id={`${name}`}
				name={`${name}`}
				clearable={true}
				value={selectedValues}
				data={listItemsSelect}
				onChange={setSelectedValues}
				onBlur={validation.handleBlur}
				maxSelectedValues={1}
				searchable
				placeholder={isLoading ? 'Cargando...' : `Seleccione ${label}`}
				disabled={isLoading ? true : isDisabled}
				error={
					validation.touched[`${name}`] && validation.errors[`${name}`]
						? validation.errors[`${name}`]
						: ''
				}
				{...(isMulti && {
					multiple: true,
					maxSelectedValues: maxSelectedValues || '',
				})}
				onDropdownClose={() => setIsDropdownOpen(false)}
				onDropdownOpen={() => setIsDropdownOpen(true)}
			/>
		</React.Fragment>
	);
};

export default OSelect;
